import { render, staticRenderFns } from "./DocumentTemplateDetailNewForm.vue?vue&type=template&id=cca4b666"
import script from "./DocumentTemplateDetailNewForm.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateDetailNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports